export default __webpack_public_path__ + "static/media/DeleteAccount.0504be6f.svg";